import { MenuFamily } from '../../app/types/catalog-types'
import { urls } from '../../navigation'
import { Link } from 'react-router-dom'
import { useURLLang } from '../../app/main-slice'
import { useMessages2 } from '../../hooks/useLanguage'
import styles from './choose-family.module.css'
import ChooseHeader from '../../controls/chooseHeader/choose-header'

export function ChooseFamily({ categoryId, families }: {
    categoryId: string
    families: MenuFamily[]
}) {

    const lang = useURLLang();
    const { messages } = useMessages2();

    const urlLink = (family: MenuFamily) => {
        if(family?.hasVariants){
            return urls.family(lang, categoryId, family.id)
        } else{
            if(family?.isCategory){
                return urls.subFamily(lang, categoryId, family.id)
            } else {
                return urls.familyCfg(lang, categoryId, family.id)
            }
        }
    }

    return <>
        <ChooseHeader title={messages?.intro_category_question || ""} urlBack={urls.home(lang)}/>
            
        <ul className={styles.familyContainer}>
            {
                families.map((family, index) => 
                    <li className={`${styles.productCard} ${index%2===1 ? styles.productR : styles.productL}`} key={family.id}>
                       {family?.image && <Link className={styles.productLink} to={ urlLink(family) }>
                            <div className={styles.imageCard} dangerouslySetInnerHTML={{ __html: family?.image || "" }}/>
                            <span className={styles.familyName}>{ family.name }</span>
                        </Link>}
                    </li>)
            }
        </ul>
    </>

}